import React, { useContext, useState } from 'react'
import { VehicleContext } from '../../SingleVehicle'
import { Alert, Button, Stack } from '@mui/material'
import { SectionHeader } from '../SectionKit'
import CustomDataGrid from '../../../../../components/DataGrid/CustomDataGrid'
import moment from 'moment'
import BigModal from '../../../../../components/Modals/BigModal'
import AddNewService, { serviceModalStyle } from './AddService'
import AddIcon from '@mui/icons-material/Add'
import AttachmentIcon from '@mui/icons-material/Attachment'
import Box from '@mui/material/Box'
import S3DocumentUploadDisplay from '../../../../../components/images/S3DocumentUploadDisplay'
import ServiceModal from './ServiceModal'
import { TenantSettingsContext } from '../../../../../App'

const Services = () => {
  const [openAddNew, setOpenAddNew] = useState(false)
  const { vehicle } = useContext(VehicleContext)
  const [selectedService, setSelectedService] = useState(null)
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig

  const sortedServices = vehicle?.services
    ? [...vehicle.services].sort((a, b) => moment(b.date) - moment(a.date))
    : []

  return (
    <Stack spacing={1.5}>
      <SectionHeader
        title="Services"
        action={
          <Button
            variant="outlined"
            size="small"
            onClick={() => setOpenAddNew(true)}
            startIcon={<AddIcon />}
          >
            Add Service
          </Button>
        }
      />
      {vehicle?.services?.length >= 1 ? (
        <CustomDataGrid
          rows={sortedServices}
          maxHeight={400}
          columns={[
            {
              field: 'date',
              headerName: 'Date',
              renderCell: ({ value }) => moment(value).format('DD/MM/YYYY'),
              minWidth: 150,
            },

            { field: 'mileage', headerName: 'Mileage', minWidth: 120 },
            { field: 'garage', headerName: 'Garage', minWidth: 150 },
            {
              field: 'workCompleted',
              headerName: 'Work Completed',
              minWidth: 200,
              flex: 1,
            },
            {
              field: 'cost',
              headerName: 'Cost',
              minWidth: 110,
              renderCell: ({ value }) =>
                value != null ? `${orgSettings?.currency ?? '£'}${Number(value).toFixed(2)}` : '—',
            },
            {
              field: 'documents',
              headerName: 'Documents',
              minWidth: 100,
              align: 'center',
              headerAlign: 'center',
              renderCell: ({ value }) => (
                <Box
                  alignItems="center"
                  justifyContent="center"
                  width="100%"
                  height="100%"
                  display="flex"
                >
                  {value.length >= 1 && <AttachmentIcon color="primary" />}
                </Box>
              ),
            },
          ]}
          getRowId={(row) => row._id}
          slots={{
            toolbar: () => null,
            footer: () => null,
          }}
          disableRowSelectionOnClick
          onRowClick={({ row }) => setSelectedService(row)}
        />
      ) : (
        <Alert severity="info">No Services Yet</Alert>
      )}
      <BigModal
        open={openAddNew}
        onClose={() => setOpenAddNew(false)}
        style={serviceModalStyle}
      >
        <AddNewService onClose={() => setOpenAddNew(false)} />
      </BigModal>
      <BigModal
        open={!!selectedService}
        onClose={() => setSelectedService(null)}
        hideBackgroundColor
      >
        <ServiceModal selectedService={selectedService} setSelectedService={setSelectedService} />
      </BigModal>
    </Stack>
  )
}

export default Services
